import type { ISocketProvider, WebSocketLike } from "./types";

export interface EmbeddedSocketConfig {
  getSocket: () => WebSocketLike | null;
  onConnectionChange?: (callback: (isConnected: boolean) => void) => () => void;
}

export class EmbeddedSocketProvider implements ISocketProvider {
  private config: EmbeddedSocketConfig;

  constructor(config: EmbeddedSocketConfig) {
    this.config = config;
  }

  connect(token?: string): void {
    void token;
    console.warn("Socket connection is managed by parent application");
  }

  disconnect(): void {
    console.warn("Socket disconnection is managed by parent application");
  }

  getSocket(): WebSocketLike | null {
    return this.config.getSocket();
  }

  isConnected(): boolean {
    const socket = this.config.getSocket();
    return socket?.connected ?? false;
  }

  emit(event: string, data?: unknown): void {
    const socket = this.config.getSocket();
    if (!socket) {
      console.warn("Socket not available, cannot emit event:", event);
      return;
    }

    socket.emit(event, data);
  }

  on(event: string, handler: (...args: unknown[]) => void): void {
    const socket = this.config.getSocket();
    if (!socket) {
      console.warn("Socket not available, cannot listen to event:", event);
      return;
    }

    socket.on(event, handler);
  }

  off(event: string, handler?: (...args: unknown[]) => void): void {
    const socket = this.config.getSocket();
    if (!socket) {
      return;
    }

    if (handler) {
      socket.off(event, handler);
    } else {
      socket.off(event);
    }
  }

  onConnectionChange(callback: (isConnected: boolean) => void): () => void {
    if (this.config.onConnectionChange) {
      return this.config.onConnectionChange(callback);
    }
    return () => {
      // Empty unsubscribe
    };
  }
}
